import React, { useEffect } from "react";
import Cards from "./Cards";
import LeafletMap from "./LeafletMap";

function WaterHarvOverview() {
  
  useEffect(() => {
    window?.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="white_card  flex-1 min-h-[85vh]">
      <div className="form-add-h">Water Harvesting</div>
      <Cards />
      <div className="mt-[1.25rem]">
        <LeafletMap />
      </div>
    </div>
  );
}

export default WaterHarvOverview;
